
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/[...all]",
      function () {
        return require("private-next-pages/legal/[...all].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/[...all]"])
      });
    }
  